module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/ladder-0-5cb6acfd1a55b82e.png"+" 221w",
        images: [{path: __webpack_public_path__ + "assets/images/ladder-0-5cb6acfd1a55b82e.png",width: 221,height: 464}],
        src: __webpack_public_path__ + "assets/images/ladder-0-5cb6acfd1a55b82e.png",
        toString: function(){return __webpack_public_path__ + "assets/images/ladder-0-5cb6acfd1a55b82e.png"},
        
        width: 221,
        height: 464
      }